import { ApiParameters } from './api-parameters';
import { SimplePlayer } from '../../simple-player';
import { ApiPutRequest } from './api-put-request';

export class PlayerPutRequest extends ApiPutRequest
{

    public constructor(
        player: SimplePlayer,
        webapiBasepath: string
    )
    {
        super(  'player', 
                new ApiParameters(), 
                null, 
                {
                    player
                },
                webapiBasepath
            );
    }
}
